import { colors } from '../../../theme/colors'

export type ChartColorMode = {
  titleColor: string
  subtitleColor: string
  legendLabelColor: string
  axisLabelColor: string
  axisTickFill: string
  dataLabelFill: string
  barBackground: string
  barStroke: string
  pieSliceStroke: string
  pieCenterTotalFill: string
  pieCenterCaptionFill: string
  piePercentLabelFill: string
  pieLegendLabelColor: string
  lineDotStroke: string
  rechartsAxisTick: { fill: string; fontSize: number; fontWeight: number }
}

const neutral = colors.presets.neutral

/** Resolve chart chrome colors from the active page color mode (light vs dark). */
export const getChartColorMode = (isDark: boolean): ChartColorMode => {
  if (isDark) {
    return {
      titleColor: 'white',
      subtitleColor: 'presets.neutral.0',
      legendLabelColor: 'white',
      axisLabelColor: 'white',
      axisTickFill: neutral[0],
      dataLabelFill: neutral[0],
      barBackground: colors.chart.barBackground,
      barStroke: 'rgba(255, 255, 255, 0.22)',
      pieSliceStroke: 'rgba(255, 255, 255, 0.1)',
      pieCenterTotalFill: neutral[0],
      pieCenterCaptionFill: neutral[0],
      piePercentLabelFill: neutral[0],
      pieLegendLabelColor: 'white',
      lineDotStroke: neutral[0],
      rechartsAxisTick: { fill: neutral[0], fontSize: 10, fontWeight: 600 },
    }
  }

  return {
    titleColor: 'presets.neutral.100',
    subtitleColor: 'presets.neutral.70',
    legendLabelColor: 'presets.neutral.90',
    axisLabelColor: 'presets.turquoise.100',
    axisTickFill: neutral[100],
    dataLabelFill: neutral[100],
    barBackground: colors.presets.overlay.black03,
    barStroke: 'rgba(0, 0, 0, 0.08)',
    pieSliceStroke: neutral[0],
    pieCenterTotalFill: neutral[90],
    pieCenterCaptionFill: neutral[70],
    piePercentLabelFill: neutral[90],
    pieLegendLabelColor: 'presets.neutral.90',
    lineDotStroke: neutral[0],
    rechartsAxisTick: { fill: neutral[100], fontSize: 10, fontWeight: 500 },
  }
}
